var React = require('react');

function LineSecondRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#dae0e5","strokeWidth":"2","d":"m168.525133,1l0,329.469927l-167.525133,0l0,88.1015"}));
}

LineSecondRight.defaultProps = {"height":"420","width":"170","viewBox":"0 0 170 420"};

module.exports = LineSecondRight;

LineSecondRight.default = LineSecondRight;
